module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"defaultMessage":"There is no data for this selection."},"de":{"defaultMessage":"Für diese Auswahl sind leider keine Daten vorhanden."},"fr":{"defaultMessage":"Il n\u0027y a pas de données pour cette sélection."},"it":{"defaultMessage":"Non sono presenti dati per questa selezione."}}')
  delete Component.options._Ctor
}
